import { Location } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconEnum, Menu } from '@evc/web-components';
import { Inspection } from '../../_objects/inspection';
import { GeneratedReport, InspectionReport, InspectionReportListItem } from '../../_objects/inspection-report';
import { Subject } from '../../_objects/subject';
import { SubjectModel } from '../../_objects/subject-model';
import { NetworkStatusService } from '../../_services/network-status.service';
import { NavigationMenuService } from '../../shared/services/navigation-menu/navigation-menu.service';
import { InspectionDataManageService } from '../inspection-data-manage.service';

@Component({
    selector: 'app-inspection-side-contents',
    templateUrl: './inspection-side-contents.component.html',
    styleUrls: ['./inspection-side-contents.component.scss'],
    standalone: false
})
export class InspectionSideContentsComponent {

  readonly sidenavTypes = ['folder', 'report'];

  @Input() inspection: Inspection;
  @Input() inspectionImagesCount: number;
  @Input() subjectModel: SubjectModel;
  @Input() report: InspectionReport;
  @Input() historyReports: InspectionReportListItem[];
  @Input() generatedReportTree: GeneratedReport[];
  @Input() inspectionId: string[];
  @Input() isReadOnly: boolean;
  @Input() sideNavType: string;
  @Input() subjects: Subject[]; // All candidates
  @Input() contentHeight: number;
  @Input() pastReportFilter: string;
  @Input() isReportLoading: boolean;
  @Input() inspectionReport: InspectionReport;

  @Output() updateInspection = new EventEmitter();
  @Output() uploadInspectionImage = new EventEmitter();
  @Output() addInspectionReport = new EventEmitter();
  @Output() imageUpload = new EventEmitter();
  @Output() addReport = new EventEmitter();
  @Output() sideNavToggle = new EventEmitter();
  @Output() changeSideNavType: EventEmitter<string> = new EventEmitter();

  plusIcon = IconEnum.Plus;

  public leftBarMenu: Menu[] = [];
  public isLeftBarOpened = true;

  constructor(
    private networkStatusService: NetworkStatusService,
    private location: Location,
    private inspDataManageService: InspectionDataManageService,
    private navigationMenuService: NavigationMenuService
  ) {
    this.leftBarMenu = this.navigationMenuService.buildLeftMenu(this.networkStatusService.isOnline);
  }

  get subjects4Inspections(): Subject[] {
    if (!this.subjects || !this.inspection) {
      return [];
    }
    return this.subjects.filter(subject => this.inspection.subjectId === subject.id);
  }

  get isDeletedInspection(): boolean {
    return !this.inspection || (this.inspection.isDeleted);
  }

  changeSidenav(sideNavType: string): void {
    this.sideNavType = sideNavType;
    this.location.replaceState(['/inspection-data-management/inspection', this.inspection.id].join('/'));
    this.inspDataManageService.isReportView = false;
  }

  upload() {
    this.imageUpload.emit();
  }

  leftBarIsOpenChange(isOpen: boolean) {
    this.isLeftBarOpened = isOpen;
  }

  createReport() {
    this.addReport.emit();
  }

  updateInspectionEmit(inspection: Inspection): void {
    this.inspection = inspection;
    this.updateInspection.emit(inspection);
  }
}
